import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolderPencil = () => {
  return (
    <g>
      <path d="m12.769 8.1772a.75.75 0 0 0 -.75.75v4.127h-10.4843v-7.8174h7.0141a.75.75 0 1 0 0-1.5h-1.6315l-1.0897-1.8968a.7506.7506 0 0 0 -.65-.376h-4.3929a.75.75 0 0 0 -.75.75v11.59a.75.75 0 0 0 .75.75h11.9844a.75.75 0 0 0 .75-.75v-4.8768a.75.75 0 0 0 -.7501-.75zm-8.0258-5.2128.4437.7725h-3.6522v-.7725z" />
      <path d="m15.7456 3.5474-1.8906-1.8907a.772.772 0 0 0 -1.0605 0l-1.6129 1.6133-4.0293 4.0293a.75.75 0 0 0 -.22.541l.0277 1.8633a.75.75 0 0 0 .7388.7393l1.8632.0271h.0112a.75.75 0 0 0 .53-.22l4.0268-4.0262.0018-.0009.0022-.0029 1.6116-1.6118a.75.75 0 0 0 0-1.0608zm-2.4209-.3.83.83-.5531.5531-.83-.83zm-4.0576 5.7179-.8179-.0117-.0122-.8183 3.2743-3.2743.83.83z" />
    </g>
  );
};

export default withIcon(IconFolderPencil);
